import axios from "axios";
import { RealTimeNotification } from "../types";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

interface NotificationResponse {
  notifications: RealTimeNotification[];
  unreadCount: number;
  total: number;
}

class NotificationService {
  private getAuthHeaders() {
    const token = localStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async getNotifications(
    limit: number = 50,
    skip: number = 0
  ): Promise<NotificationResponse> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/notifications?limit=${limit}&skip=${skip}`,
        {
          headers: this.getAuthHeaders(),
        }
      );
      return response.data.data;
    } catch (error) {
      // Error fetching notifications
      throw error;
    }
  }

  async markAsRead(notificationId: string): Promise<void> {
    try {
      await axios.patch(
        `${API_BASE_URL}/notifications/${notificationId}/read`,
        {},
        {
          headers: this.getAuthHeaders(),
        }
      );
    } catch (error) {
      // Error marking notification as read
      throw error;
    }
  }

  async markAllAsRead(): Promise<number> {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/notifications/mark-all-read`,
        {},
        {
          headers: this.getAuthHeaders(),
        }
      );
      return response.data.data.updatedCount;
    } catch (error) {
      // Error marking all notifications as read
      throw error;
    }
  }

  async deleteNotification(notificationId: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/notifications/${notificationId}`, {
        headers: this.getAuthHeaders(),
      });
    } catch (error) {
      // Error deleting notification
      throw error;
    }
  }

  async clearAllNotifications(): Promise<number> {
    try {
      const response = await axios.delete(`${API_BASE_URL}/notifications`, {
        headers: this.getAuthHeaders(),
      });
      return response.data.data.deletedCount;
    } catch (error) {
      // Error clearing all notifications
      throw error;
    }
  }

  async getUnreadCount(): Promise<number> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/notifications/unread-count`,
        {
          headers: this.getAuthHeaders(),
        }
      );
      return response.data.data.unreadCount;
    } catch (error) {
      // Error getting unread count
      return 0;
    }
  }
}

export const notificationService = new NotificationService();
